<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <span class="text"
    >Please confirm that your official documents have been uploaded and are
    accurate and up-to-date. If any information is incorrect, kindly click on
    the edit icon to make the necessary updates. However, you can send us a chat
    message
    <a [routerLink]="['/contractor/chat-window']" routerLinkActive="active"
      >here</a
    >
    if you have any question or feedback.</span
  >
</div>

<div
  class="ui vertical basic segment"
  *ngIf="success || error"
  appMargin
  marginB="10px"
>
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  appMargin="0"
  appPadding="0"
>
  <div
    class="record-holder"
    *ngFor="let record of documentTypesCombined; let i = index"
    appMargin
    marginB="22px"
  >
    <div
      class=""
      fxLayout="row"
      fxLayoutGap="14px"
      fxLayoutAlign="start center"
      appPadding
      padding="0"
    >
      <div fxFlex="28px">
        <div
          class="ui circular label record"
          [ngClass]="{
            blue: returnLength(record?.value) > 0,
            grey: returnLength(record?.value) < 1
          }"
        >
          {{ returnLength(record?.value) }}
        </div>
      </div>
      <div fxFlex="70%" class="record-name">
        {{ record?.documentTypeName }}
      </div>

      <div fxFlex="25%" fxLayout="row" fxLayoutAlign="end center">
        <div class="is-mandatory" *ngIf="record?.isRequired">
          <div class="ui medium grey circular label">MANDATORY</div>
        </div>
        <button
          class="ui tiny circular icon button chev"
          (click)="toggleAffiliateTypesVisibility(i, record?.documentTypeId)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          [popupText]="
            expandedID === record?.documentTypeId
              ? 'Hide official Types'
              : 'Show official Types'
          "
        >
          <i
            style="vertical-align: middle !important"
            [class]="
              expandedID === record?.documentTypeId
                ? 'chevron up icon'
                : 'chevron down icon'
            "
          ></i>
        </button>
      </div>
    </div>

    <div [suiCollapse]="expandedID !== record?.documentTypeId">
      <div class="" appPadding="0">
        <p class="record-text">
          This document, issued by CAC, outlines the company's objectives,
          shareholders, subscribed shares, and operational regulations.
        </p>
        <app-official-list
          [totalHistory]="totalItemsHistory"
          [allHistoryData]="allHistory"
          [documentTypeId]="record?.documentTypeId"
          [activeId]="expandedID"
          [archivedDocu]="archivedDocuments"
          [documentStatus]="documentStatus"
          [documents]="record?.value"
          (verificationStatus)="getVerificationStatus()"
          (upload)="addDocument()"
          (onView)="view($event)"
          (onArchive)="onArchive($event)"
          (download)="download($event)"
          (edit)="editDocument($event)"
          (history)="viewHistory($event)"
          (uploadDoc)="uploadDoc($event)"
          (editDoc)="editDoc($event)"
          (removeArchive)="onUnArchive($event)"
          (removeDocument)="removeDocument($event)"
        >
        </app-official-list>
      </div>
    </div>
  </div>

  <app-no-record-found
    *ngIf="documentTypesCombined && documentTypesCombined?.length < 1"
  ></app-no-record-found>
</div>
